
import { jsonp } from '../assets/js/common.js';
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Panel from 'vux/src/components/panel/index.vue'


export default {
created() {
this.getData();
},
data() {
return {
scrollTop: 0,
bottomCount: 20,
dataList: [],
header: '',
isLoadMoreShow: true
}
},
methods: {

getData() {
jsonp('/us_box').then(res => {
this.isLoadMoreShow = false;
this.header = `时间：${res.date}`;

res.subjects.forEach((elem) => {
elem.title = `<strong>${elem.rank}</strong>  ${elem.subject.title}`;
elem.src = elem.subject.images.small;
elem.fallbackSrc = '../assets/fallback.png';
var directors = elem.subject.directors.map((elem) => {
return elem.name;
}).join(' '),
casts = elem.subject.casts.map((elem) => {
return elem.name;
}).join(' ');
elem.desc = `<p>类型：${elem.subject.genres.join(' ')}</p>
<p>导演：${directors}</p>
<p>主演：${casts}</p>
<p class='clearfix'><span class='pl'>已看人数：${elem.subject.collect_count}</span><span class='pr'>评分：${elem.subject.rating.average}</span></p>`;
elem.url = `/moviedetail/${elem.subject.id}`
}, this);
this.dataList = this.dataList.concat(res.subjects);
}).catch(ex => {
console.error(ex);
});
},

onImgError(item, $event) {
console.log(item, $event)
}
},
components: {
Scroller,
LoadMore,
Panel
},
props: ['heightData']
}



// WEBPACK FOOTER //
// ./src/components/US_box.vue